export function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function setCookie(name, value, maxAge, domain) {
  let expires = "";
  if (maxAge) expires = "; max-age=" + `${maxAge}`;
  domain = domain ? `; domain=${domain}` : ``;
  document.cookie = name + "=" + (value || "") + expires + "; path=/" + domain;
}

export function deleteCookie(name) {
  document.cookie = `${name}=; expires=${new Date()}; path=/`;
}
